import Vue from 'vue';

import AppCard from '@/components/Layout/AppCard.vue';
import AppInput from '@/components/Layout/Inputs/AppInput.vue';
import AppFilePicker from '@/components/Layout/Inputs/AppFilePicker.vue';
import AppAutocomplete from '@/components/Layout/Inputs/AppAutocomplete.vue';
import AppPageHeader from '@/components/Layout/AppPageHeader.vue';
import AppSideMenu from '@/components/Layout/AppSideMenu.vue';
import AppToolbar from '@/components/Layout/AppToolbar.vue';
import AppNetworkSelect from '@/components/Layout/Inputs/AppNetworkSelect';

Vue.component('app-card', AppCard);
Vue.component('app-input', AppInput);
Vue.component('app-file-picker', AppFilePicker);
Vue.component('app-autocomplete', AppAutocomplete);
Vue.component('app-page-header', AppPageHeader);
Vue.component('app-side-menu', AppSideMenu);
Vue.component('app-toolbar', AppToolbar);
Vue.component('app-network-select', AppNetworkSelect);
